<script setup>
import {
	Toggle,
	Tabs,
	Tab,
	Card,
	Label,
	Input,
	Hint,
	ColorPicker,
	Textarea,
	Select,
	Button,
	Icon,
	Modal,
	Checkbox,
	ProfilePicture,
	InputPrice,
} from "@components";
import { ref, reactive, onMounted, computed, watch } from "vue";
import {
	durations,
	progress,
	getPrice,
	isInteger,
	validationCheck,
	regex,
} from "@utils";

// Route.
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

// Service
import { useService } from "@store/service";
const $service = useService();
// Staff
import { useStaff } from "@store/staff";
const $staff = useStaff();

// Appointment
import { useAppointment } from "@store/appointment";
const $appointment = useAppointment();

// Customer
import { useCustomer } from "@store/customer.js";
const $customer = useCustomer();

// Transaction
import { useTransaction } from "@store/transaction.js";
const $transaction = useTransaction();

// Settings store.
import { useSettings } from "@store/settings";
const $settings = useSettings();

import moment from "moment";

const appointmentId = computed(() => {
	return route.params.appointmentId;
});
const isNew = computed(() => {
	return !appointmentId.value;
});
const state = reactive({
	addTransaction: false,
	paid_amount: 0,
	payment_method: $settings.payment.default_payment_method || "cash",
	payment_status: "paid",
});
const $options = prebook_admin.options;
const appointment = ref({
	status: "pending",
	meta: {
		price: 0,
		deposit_amount: 0,
		payment_method: "cash",
		payment_status: "paid",
		appointment_type: "Onsite",
	},
});

const isAppointmentChanged = ref(false)	

watch(appointment, (newValue, oldValue) => {
	isAppointmentChanged.value = true
	console.log('isAppointmentChanged function', isAppointmentChanged.value)
}, { deep: true });

const services = ref([]);
const staffs = ref([]);
// const customers = ref([])

// Save mechanism for appointment.
const save = async (type) => {
	let customerExist = $customer.getCustomers.find(
		(c) => c.email == appointment.value.meta.customer_email
	);

	// Create new customer if not exist
	if (!customerExist) {
		let newCustomer = await $customer.model().create({
			display_name:
				appointment.value.meta.customer_first_name +
				" " +
				appointment.value.meta.customer_last_name,
			email: appointment.value.meta.customer_email,
			meta: {
				first_name: appointment.value.meta.customer_first_name,
				last_name: appointment.value.meta.customer_last_name,
				phone: appointment.value.meta.customer_phone,
				address: "",
				status: "publish",
			},
		});

		appointment.value.customer_id = newCustomer.data.customer_id;
		await $customer.fetchCustomers();
		const customer = $customer.getCustomers.find(
			(customer) => customer.customer_id == appointment.value.customer_id
		);
		changeCustomer(customer);
	}

	// if staff addon is disabled
	// if (!$settings.addons.staffs) {
	//     let findProvider = $staff.getStaffs.find(s => s.meta.timezone)// change meta.timezone to meta.provider

	//     if (findProvider) {
	//         appointment.value.staff_id = findProvider.staff_id
	//     }
	// }

	// validation
	let { errors } =
		type !== "draft"
			? validationCheck([
					{
						condition: !appointment.value.service_id,
						message: `Please select a ${String(
							$settings.labels.service?.singular
						).toLowerCase()}`,
					},
					// {
					//     condition: !isInteger(appointment.value.meta.service_duration),
					//     message: `${$settings.labels.service?.singular} duration must be an integer number`,
					// },
					{
						condition: $settings.addons.staffs && !appointment.value.staff_id,
						message: `Please select a ${String(
							$settings.labels.staff?.singular
						).toLowerCase()}`,
					},
					{
						condition: !appointment.value.customer_id,
						message: `Please select a ${String(
							$settings.labels.customer?.singular
						).toLowerCase()}`,
					},
					{
						condition:
							appointment.value.customer_id &&
							(!appointment.value.meta.customer_first_name ||
								!appointment.value.meta.customer_last_name),
						message: `Please enter ${String(
							$settings.labels.customer?.singular
						).toLowerCase()} name`,
					},
					{
						condition:
							appointment.value.customer_id &&
							!appointment.value.meta.customer_email,
						message: `Please enter ${String(
							$settings.labels.customer?.singular
						).toLowerCase()} email`,
					},
					{
						condition:
							appointment.value.customer_id &&
							appointment.value.meta.customer_email &&
							!regex.email.test(appointment.value.meta.customer_email),
						message: `Invalid ${String(
							$settings.labels.customer?.singular
						).toLowerCase()} email format`,
					},
					{
						condition:
							appointment.value.customer_id &&
							!appointment.value.meta.customer_phone,
						message: `Please enter ${String(
							$settings.labels.customer?.singular
						).toLowerCase()} phone number`,
					},
					{
						condition:
							appointment.value.customer_id &&
							!regex.phone.test(appointment.value.meta.customer_phone),
						message: `Invalid ${String(
							$settings.labels.customer?.singular
						).toLowerCase()} phone number format`,
					},
					{
						condition: !appointment.value.booking_date,
						message: `Please select a ${String(
							$settings.labels.appointment?.singular
						).toLowerCase()} date`,
					},
					{
						condition:
							!appointment.value.booking_time_start ||
							!appointment.value.booking_time_end,
						message: `Please select a ${String(
							$settings.labels.appointment?.singular
						).toLowerCase()} time`,
					},
					{
						condition:
							isPaymentShow.value &&
							isNew.value &&
							(!state.paid_amount || state.paid_amount <= 0),
						message: `${$settings.labels.payment?.singular} amount must be greater than 0`,
					},
					{
						condition:
							isPaymentShow.value && isNew.value && !state.payment_method,
						message: `Please select a ${String(
							$settings.labels.payment?.singular
						).toLowerCase()} method`,
					},
			  ])
			: false;
	if (errors) return (state.saving = false);

	appointment.value.status = type;

	// after validation submit form
	state.saving = false;
	Log("Appointment", appointment.value);

	if (isNew.value) {
		appointment.value.payment_status = "paid";
		const response = await $appointment.model().create(appointment.value);

		if (response.success) {
			// submit transaction
			if (isPaymentShow.value) {
				appointment.value.appointment_id = response.data.appointment_id;
				await submitTransaction(false);
			}

			// route to, no push
			// router.push({
			//     name: 'appointment.edit',
			//     params: {
			//         ...route.params,
			//         appointmentId: response.data.appointment_id,
			//     },
			//     query: { ...route.query },
			// })

			// back to list page [issue #82]
			router.push({ name: "appointment.list" });

			isPaymentShow.value = false;
			appointment.value.appointment_id = response.data.appointment_id;

			if (type === "draft") {
				Toast.success(
					`${
						$settings.labels.appointment?.singular ?? "Appointment"
					} draft saved successfully`
				);
			} else {
				Toast.success(
					`${
						$settings.labels.appointment?.singular ?? "Appointment"
					} added successfully`
				);
			}

			// Fetch Transactions.
			await $transaction.fetchTransactions();
		} else {
			Toast.error(
				`${$settings.labels.appointment?.singular ?? "Appointment"} not added`
			);
		}
	} else {
		const response = await $appointment
			.model()
			.update(appointment.value, appointment.value.appointment_id);

		if (response.success) {
			if (type === "draft") {
				Toast.success(
					`${
						$settings.labels.appointment?.singular ?? "Appointment"
					} draft saved successfully`
				);
			} else {
				Toast.success(
					`${
						$settings.labels.appointment?.singular ?? "Appointment"
					} details updated successfully`
				);
			}

			// back to list page [issue #82]
			router.push({ name: "appointment.list" });
		} else {
			Toast.error("Something went wrong");
		}
	}

	state.saving = false;
};

// Button behavior.
const publish = async () => {
	// appointment.value.status = 'publish'
	state.saving = "publish";
	await save("publish");
};

const draft = async () => {
	// appointment.value.status = 'draft'
	state.saving = "draft";
	await save("draft");
};

const publishButton = computed(() => {
	if (appointment.value.status !== "publish" || isNew.value) {
		return state.saving == "publish" ? "Publishing" : "Publish";
	}

	return state.saving == "publish" ? "Updating" : "Update";
});

const draftButton = computed(() => {
	return state.saving == "draft" ? "Saving" : "Save as draft";
});

// States of the object.
const object_states = computed(() => {
	if (!appointment.value.status) return [];
	let _states = [];

	if (appointment.value.status && appointment.value.status === "draft") {
		_states.push("Draft");
	}

	if (appointment.value.is_private) {
		_states.push("Private");
	}

	return _states;
});

const statusOptions = ref([]);

onMounted(async () => {
	statusOptions.value = [
		// {
		//     label: 'Status: All',
		//     value: 'all'
		// },
		{
			label: "Approved",
			value: "approved",
		},
		{
			label: "Pending",
			value: "pending",
		},
		{
			label: "Canceled",
			value: "canceled",
		},
		{
			label: "Rejected",
			value: "rejected",
		},
	];

	state.loading = true;
	$transaction.fetchTransactions();
	// Fetch customers.
	await $customer.fetchCustomers();

	// customers.value = $customer.getCustomers.filter(customer => customer.meta.status === 'publish').map(customer => {
	//     return {
	//         label: customer.name || 'N/A',
	//         value: customer.customer_id
	//     }
	// })

	// Fetch Categories with services.
	await $service.fetchData();

	services.value = $service.getServices
		.filter((service) => service.status === "publish")
		.map((service) => {
			return {
				label: service.name,
				value: service.service_id,
			};
		});

		setTimeout(() => {
			isAppointmentChanged.value = false
		}, 2000)

	if (isNew.value) {
		router.replace({
			query: {
				...route.query,
				tab: "details",
			},
		});

		// Sync category id.
		if (route.query.customerId) {
			appointment.value.customer_id = Number(route.query.customerId) || "";
			const customer = $customer.getCustomers.find(
				(customer) => customer.customer_id == appointment.value.customer_id
			);
			changeCustomer(customer);
		}

		state.loading = false;
		
		// set default payment method.
		appointment.value.meta.payment_method =
			prebook_admin.settings.payment.default_payment_method;

		// set default status.
		appointment.value.meta.status =
			prebook_admin.settings.appointment.default_status;

		// Set address.
		appointment.value.meta.address = [
			prebook_admin.settings.business.street,
			prebook_admin.settings.business.city,
			prebook_admin.settings.business.state,
			prebook_admin.settings.business.zip_code,
			prebook_admin.settings.business.country,
		]
			.filter(Boolean)
			.join(", ");

		isAppointmentChanged.value = false
		return;
	}
	console.log('isAppointmentChanged', isAppointmentChanged.value)

	// Fetch Appointments.
	appointment.value = await $appointment
		.model(router.currentRoute.value.params.appointmentId)
		.get();
	Log("APPOINTMENT", appointment.value);

	$appointment.fetchAvailableDates(appointment.value.service_id);
	// $appointment.fetchAvailableSlots(appointment.value.booking_date, appointment.value.service_id, appointment.value.staff_id, appointment.value.customer_id)

	let staffsByService = await $staff.fetchStaffByService(
		appointment.value.service_id
	);

	staffs.value = staffsByService
		.filter((staff) => staff.meta.status === "publish")
		.map((staff) => {
			return {
				label: staff.name,
				value: staff.staff_id,
				img: staff.meta?.profile_image_url,
			};
		});

	// if appointed staff is service provider and not assing on that service then include that staff
	if (
		appointment.value.staff_id &&
		!staffsByService.find(
			(staff) => staff.staff_id == appointment.value.staff_id
		)
	) {
		let staff = await $staff.getStaffById(appointment.value.staff_id);
		staffs.value.push({
			label: staff.name,
			value: staff.staff_id,
			img: staff.meta?.profile_image_url,
		});
	}

	// Not loading.
	state.loading = false;
	isAppointmentChanged.value = false
});

const changeService = async (service_id) => {
	state.loading = true;

	let service = await $service.getServiceById(service_id);
	// console.log(service);
	if (!service) return;
	appointment.value.meta.service_name = service.name;
	appointment.value.meta.service_duration = service.meta.duration;
	appointment.value.meta.service_duration_unit = service.meta.duration_unit;
	appointment.value.meta.price = service.meta.price;

	let staffsByService = await $staff.fetchStaffByService(service_id);

	staffs.value = staffsByService.map((staff) => {
		return {
			label: staff.name,
			value: staff.staff_id,
			img: staff.meta?.profile_image_url,
		};
	});

	appointment.value.staff_id = "";
	appointment.value.meta.staff_email = "";
	appointment.value.meta.staff_phone = "";
	appointment.value.booking_date = "";
	appointment.value.booking_time_start = "";
	appointment.value.booking_time_end = "";
	$appointment.availableDates = [];
	$appointment.availableSlots = [];

	state.loading = false;

	// Load available dates.
	await $appointment.fetchAvailableDates(service_id);
};

const changeStaff = async (staff_id = null) => {
	state.loading = true;

	let staff = await $staff.fetchStaffs(staff_id);

	if (!staff) return;
	// console.log("123", staff);
	appointment.value.meta.staff_name = staff.name;
	appointment.value.meta.staff_email = staff.email;
	appointment.value.meta.staff_phone = staff.meta.phone;

	await $appointment.fetchAvailableDates(
		appointment.value.service_id,
		staff_id
	);

	appointment.value.booking_date = "";
	appointment.value.booking_time_start = "";
	appointment.value.booking_time_end = "";
	$appointment.availableSlots = [];

	state.loading = false;
};

const backButton = async () => {
	if (isAppointmentChanged.value) {
		const choice = await Prompt.fire({
			title: 'Unsaved Changes Detected',
			message: `You have unsaved changes. Any unsaved changes will be lost. <br> Are you sure you want to continue?`,
			ok: 'Yes, proceed',
			cancel: 'No, cancel',
		});
		if (!choice.ok) return;
	}
	if (route.query.backTo) {
		router.push(route.query.backTo);
	} else {
		router.push({ name: "appointment.list" });
	}
};

const isPaymentShow = ref(false);
// const toggleAddPayment = () => {
//     isPaymentShow.value = !isPaymentShow.value
// }

const getTransactionsByAppointmentId = computed(() => {
	// console.log($transaction.getTransactions)
	return $transaction.getTransactions.filter(
		(transaction) =>
			transaction.appointment_id == appointment.value.appointment_id
	);
});

// Transatin.

// const totalPrice = computed(() => {
//     return getTransactionsByAppointmentId.value.reduce((acc, transaction) => {
//         return acc + Number(transaction.payment_amount)
//     }, 0)
// })

const totalPaid = computed(() => {
	return getTransactionsByAppointmentId.value.reduce((acc, transaction) => {
		return (
			acc +
			(transaction.payment_status === "paid"
				? Number(transaction.payment_amount)
				: 0)
		);
	}, 0);
});

const totalDue = computed(() => {
	return appointment.value.meta.price - totalPaid.value;
});

const submitTransaction = async (alert = true) => {
	// validation
	let { errors } = validationCheck([
		{
			condition: !state.paid_amount || state.paid_amount <= 0,
			message: "Paid amount must be greater than 0",
		},
		{
			condition: !state.payment_method,
			message: "Please select a payment method",
		},
	]);
	if (errors) return (state.saving = false);

	// after validation submit form
	state.loading = true;
	let transaction = {
		appointment_id: appointment.value.appointment_id,
		customer_id: appointment.value.customer_id,
		payment_amount: state.paid_amount || 0,
		payment_method: state.payment_method || "cash",
		payment_status: state.payment_status || "paid",
	};

	let response = await $transaction.model().create(transaction);

	if (response.success) {
		alert
			? Toast.success(
					`${$settings.labels.payment?.singular} added successfully`
			  )
			: null;

		// Load transactions.
		await $transaction.fetchTransactions();

		state.addTransaction = false;
		state.payment_method = "";
		state.paid_amount = 0;
	} else {
		Toast.error(`${$settings.labels.payment?.singular} not added`);
	}

	state.loading = false;
};

const findCustomer = ref(false);
const staffSearch = ref("");
const customerSearchList = computed(() => {
	if (!staffSearch.value) return $customer.getCustomers || [];

	return $customer.getCustomers.filter(
		(c) =>
			String(c.ucid).toLowerCase().includes(staffSearch.value.toLowerCase()) ||
			String(c.name).toLowerCase().includes(staffSearch.value.toLowerCase()) ||
			String(c.email).toLowerCase().includes(staffSearch.value.toLowerCase()) ||
			String(c.meta.phone)
				.toLowerCase()
				.includes(staffSearch.value.toLowerCase())
	);
});

const changeCustomer = (customer) => {
	// console.log(customer);
	if (!customer.customer_id) return;
	// console.log(customer)
	appointment.value.customer_id = customer.customer_id;
	// appointment.value.meta.customer_id = customer.customer_id
	// appointment.value.meta.customer_name = customer.name
	appointment.value.meta.customer_first_name = customer.meta.first_name;
	appointment.value.meta.customer_last_name = customer.meta.last_name;
	appointment.value.meta.customer_email = customer.email;
	appointment.value.meta.customer_phone = customer.meta?.phone;

	findCustomer.value = false;
};

const showCustomerSearch = () => {
	findCustomer.value = true;
};

const hideCustomerSearch = () => {
	findCustomer.value = false;
};

// DaterPicker
import DatePicker from "./DatePicker.vue";
import SlotPicker from "./SlotPicker.vue";

const paymentMethodOptions = computed(()=>{
	return $settings.payment.methods.filter(p=>p.enabled == true).map(p=>{
		return {label: p.label, value:p.id}
	})
})
</script>

<template>
	<Modal :progress="`${$settings.addons.payment ? progress('details, payment') : progress('details')}`" :loading="state.loading">
		<!-- header  -->
		<template #header>
			<div class="px-8 py-6 border-b-[#EAECF0] border-b flex items-center justify-between shadow-[0px_3px_0px_0px_#eaecf0]">
				<div @click="backButton" class="cursor-pointer flex items-center gap-5 text-[#101828] text-lg font-semibold">
					<Icon name="arrowNarrowLeft" size="24px"></Icon>Back
				</div>
				<div v-if="!state.loading" class="flex items-center gap-4">
					<Button size="lg" type="secondary_gray" radius="square" @click.prevent="draft">{{ draftButton }}</Button>
					<Button size="lg" type="primary" radius="square" @click.prevent="publish">{{ publishButton }}</Button>
					<div @click="backButton">
						<Icon name="xClose" size="20px"></Icon>
					</div>
				</div>
				<div v-else class="flex items-center h-10">
					<Spin size="25px" />
				</div>
			</div>
		</template>
		<template #default>
			<div class="md:w-[736px] m-auto" :class="{ 'cursor-wait': state.loading }">
				<!-- page heading -->
				<div class="mb-6 flex flex-col md:flex-row md:items-center justify-between gap-3 text-[#344054] text-2xl font-semibold leading-8">
					<div>
						<div class="text-[#344054] text-sm font-semibold mb-2 capitalize">{{ $settings.labels.appointment?.singular }} Details</div>
						<div class="text-[#101828] text-3xl font-semibold flex items-center gap-3 capitalize">
							{{ $settings.labels.appointment?.singular }} ID # {{ isNew ? ''
							: $route.params.appointmentId }}
							<div class="mt-2 text-xs" v-if="object_states.length">
								- {{
								object_states.join(', ') }}
							</div>
						</div>
					</div>
					<div class="flex items-center gap-3">
						<Select :options="statusOptions" v-model="appointment.meta.status" selectionContainer="py-[10px]"></Select>
					</div>
				</div>
				<!-- form tabs -->
				<Tabs default="details">
					<Tab id="details">Details</Tab>
					<Tab id="payment" v-if="$settings.addons.payment" class="capitalize">{{ $settings.labels.payment?.singular }}</Tab>
					<!-- General  -->
					<template #details>
						<form @submit.prevent="save">
							<Card cardClass="gap-5 mb-5">
								<template #header>
									<div class="flex flex-col gap-1">
										<div class="text-[#101828] text-lg font-semibold capitalize">{{ $settings.labels.appointment?.singular }}</div>
										<div class="text-[#667085] text-sm font-normal">{{ $settings.labels.appointment?.singular }} name and details</div>
									</div>
								</template>
								<template #default>
									<div class="flex flex-col items-center gap-5">
										<div class="w-full">
											<!-- <Label>Service Name <div class="text-[#D92D20] inline-block">*</div></Label> -->
											<Select search :options="services" v-model="appointment.service_id" @change="value => changeService(value)" :placeholder="`Select ${String($settings.labels.service?.singular).toLowerCase()}`" class="my-1.5" selectionContainer="py-[10px]"></Select>
										</div>
										<!-- <div class="grid items-start w-full grid-cols-1 gap-6 md:grid-cols-2">
                                            <div class="w-full">
                                                <Label>Service Name <div class="text-[#D92D20] inline-block">*</div></Label>
                                                <Input disabled v-model="appointment.meta.service_name" class="my-1.5"></Input>
                                            </div>
                                            <div class="w-full">
                                                <Label>Duration <span v-if="appointment.meta.service_duration" class="text-xs">({{ appointment.meta.service_duration_unit }})</span></Label>
                                                <Input disabled v-model="appointment.meta.service_duration" type="number" class="my-1.5"></Input>
                                            </div>
										</div>-->
									</div>
								</template>
							</Card>
							<!-- Customer  -->
							<Card cardClass="gap-5 mb-5">
								<template #header>
									<div class="flex flex-col md:flex-row md:items-center md:justify-between">
										<div class="flex flex-col gap-1">
											<div class="text-[#101828] text-lg font-semibold capitalize">{{ $settings.labels.customer?.singular }} {{ $settings.addons.staffs ? `and ${$settings.labels.staff?.singular}` : '' }}</div>
											<div class="text-[#667085] text-sm font-normal">{{ $settings.labels.customer?.singular }} {{ $settings.addons.staffs ? `and ${String($settings.labels.staff?.singular).toLowerCase()}` : '' }} information</div>
										</div>
										<div>
											<Button v-if="!findCustomer" size="md" type="tertiary_color" classButton="capitalize hover:bg-white pr-0 hover:!bg-transparent" radius="square" @click="showCustomerSearch">
												<Icon name="searchLg"></Icon>
												Find {{ $settings.labels.customer?.singular }}
											</Button>
											<Button v-if="findCustomer" size="md" type="tertiary_gray" classButton="pr-0" radius="square" @click="hideCustomerSearch">
												<Icon name="xClose"></Icon>Cancel
											</Button>
										</div>
									</div>
								</template>
								<div class="flex flex-col items-center gap-5">
									<div class="w-full" v-if="findCustomer">
										<Input v-model="staffSearch" :autofocus="true" clearable class="w-full" :placeholder="`Search by ${String($settings.labels.customer?.singular).toLowerCase()} ID, name, email & phone`" iconLeft="searchLg"></Input>
										<div class="overflow-y-auto flex flex-col gap-1 max-h-[305px] p-1.5 rounded-lg border border-[#EAECF0] shadow-[0px_12px_16px_-4px_#10182814] mt-3">
											<div v-for="customer in customerSearchList" @click="changeCustomer(customer)" class="cursor-pointer px-1.5 hover:bg-[#F9FAFB] py-2.5 pl-2 pr-2.5 rounded-md flex gap-2">
												<ProfilePicture :name="customer?.name" :img="customer?.meta.profile_image_url" :bgColor="customer?.meta?.color" class="w-8 h-8" textClass="!text-sm" />
												<div class="w-[calc(100%-40px)]">
													<div class="flex items-center justify-between w-full mt-0.5">
														<div class="text-[#101828] text-lg font-medium">{{ customer.name || 'N/A' }}</div>
														<div class="text-[#475467] text-lg font-semibold">{{ customer.ucid || 'N/A' }}</div>
													</div>
													<div class="text-[#475467] text-base mt-1.5">{{ customer.email || 'N/A' }}</div>
													<div class="text-[#475467] text-base mt-1">{{ customer.meta?.phone || 'N/A' }}</div>
												</div>
											</div>
											<div v-if="!customerSearchList.length" class="p-2 text-center text-[red]">No {{ String($settings.labels.customer?.singular).toLowerCase() }} found</div>
										</div>
									</div>

									<div v-if="!findCustomer" class="flex flex-col md:grid items-center w-full gap-5 md:grid-cols-2">
										<div class="w-full">
											<Label>First Name</Label>
											<Input v-model="appointment.meta.customer_first_name" type="text" class="mt-1.5" />
										</div>
										<div class="w-full">
											<Label>Last Name</Label>
											<Input v-model="appointment.meta.customer_last_name" type="text" class="mt-1.5" />
										</div>
										<div class="w-full">
											<Label class="capitalize">{{ $settings.labels.customer?.singular }} Email</Label>
											<Input v-model="appointment.meta.customer_email" type="email" class="mt-1.5" />
										</div>
										<!-- <div class="w-full">
                                            <Label>Phone</Label>
                                            <Input v-model="appointment.meta.customer_phone" type="number" class="mt-1.5">
                                            </Input>
										</div>-->
										<div class="w-full">
											<Label>
												Phone
												<div class="text-[#D92D20] inline-block">*</div>
											</Label>
											<Input v-model="appointment.meta.customer_phone" placeholder="Enter phone number" type="text" class="mt-1.5"></Input>
										</div>
										<div class="w-full col-span-2">
											<Label class="capitalize">{{ $settings.labels.customer?.singular }} Note</Label>
											<Textarea v-model="appointment.meta.customer_note" class="pt-1.5" textareaClass="h-[100px]" />
										</div>
									</div>
									<!-- <div class="flex flex-col items-center w-full gap-5 md:flex-row">

                                    </div>
									-->
									<div class="w-full" v-if="$settings.addons.staffs">
										<Label class="capitalize">
											{{ $settings.labels.staff?.singular }} Name
											<div class="text-[#D92D20] inline-block">*</div>
										</Label>
										<Select :optionLeft="true" :leftType="appointment.staff_id ? 'image' : 'icon'" iconLeft="user01" :imgLeft="$staff.getStaffById(appointment.staff_id)?.meta?.profile_image_url" search :options="staffs" v-model="appointment.staff_id" @change="value => changeStaff(value)" :placeholder="`Select ${$settings.labels.staff?.singular}`" class="my-1.5" selectionContainer="py-[10px]"></Select>
									</div>
								</div>
							</Card>
							<!-- Staff  -->
							<!-- <Card cardClass="gap-5 mb-5">
                                <template #header>
                                    <div class="flex items-center justify-between">
                                        <div class="flex flex-col gap-1">
                                            <div class="text-[#101828] text-lg font-semibold">Staff</div>
                                            <div class="text-[#667085] text-sm font-normal">Staff information</div>
                                        </div>
                                    </div>
                                </template>
                                <div class="flex flex-col items-center gap-5">
                                    <div class="flex items-center w-full gap-5">
                                        <div class="w-full">
                                            <Label>Staff Name <div class="text-[#D92D20] inline-block">*</div></Label>
                                            <Select search :options="staffs" v-model="appointment.staff_id" @change="value => changeStaff(value)" placeholder="Select Staff" class="my-1.5" selectionContainer="py-[10px]"></Select>
                                        </div>
                                    </div>
                                    <div class="flex flex-col items-center w-full gap-5 md:flex-row">
                                        <div class="w-full">
                                            <Label>Staff Email</Label>
                                            <Input v-model="appointment.meta.staff_email" type="email" class="my-1.5" />
                                        </div>
                                        <div class="w-full">
                                            <Label>Phone</Label>
                                            <Input v-model="appointment.meta.staff_phone" type="number" class="my-1.5">
                                            </Input>
                                        </div>
                                    </div>
                                </div>
							</Card>-->
							<Card cardClass="gap-5 mb-5">
								<template #header>
									<div class="flex flex-col gap-1">
										<div class="text-[#101828] text-lg font-semibold">Date and Time</div>
										<div class="text-[#667085] text-sm font-normal">Date, time slot, and {{ String($settings.labels.service?.singular).toLowerCase() }} duration information</div>
									</div>
								</template>
								<template #default>
									<div class="flex flex-col items-center gap-5">
										<div class="flex flex-col items-center w-full gap-5 md:flex-row">
											<div class="w-full">
												<Label>Date</Label>
												<!-- <div class="border border-slate-300 rounded flex items-center gap-2 hover:bg-slate-100 px-5 py-2">
                                                    {{ appointment.booking_date }}
												</div>-->
												<!-- {{ appointment.booking_date }} -->
												<DatePicker v-model:date="appointment.booking_date" :serviceId="appointment.service_id" :staffId="appointment.staff_id" class="my-1.5" />
												<!-- <Select search :options="optionAvailableDates" v-model="appointment.booking_date" @change="changeDate(appointment.booking_date, appointment.service_id, appointment.staff_id, appointment.customer_id)" class="my-1.5" selectionContainer="py-[10px]"></Select> -->
											</div>
											<div class="w-full">
												<Label>Time</Label>
												<!-- {{ appointment.booking_time_start }} {{ appointment.booking_time_end }} -->
												<SlotPicker v-model:start="appointment.booking_time_start" v-model:end="appointment.booking_time_end" :date="appointment.booking_date" :serviceId="appointment.service_id" :staffId="appointment.staff_id" class="my-1.5" />
												<!-- <Select search :options="optionAvailableSlots" v-model="appointment.booking_time_start" @change="changeTime" class="my-1.5" selectionContainer="py-[10px]"></Select> -->
											</div>
											<div class="w-full">
												<Label>
													Duration
													<span v-if="appointment.meta.service_duration" class="text-xs">({{ appointment.meta.service_duration_unit || $service.getServiceById(appointment.service_id)?.meta.duration_unit }})</span>
												</Label>
												<Input disabled v-model="appointment.meta.service_duration" type="number" class="my-1.5"></Input>
											</div>
										</div>
									</div>
								</template>
							</Card>
							<!-- <Card cardClass="gap-5">
                                <template #header>
                                    <div class="flex flex-col gap-1">
                                        <div class="text-[#101828] text-lg font-semibold">Appointment type</div>
                                        <div class="text-[#667085] text-sm font-normal">Assign staffs to the service
                                            and manage commission</div>
                                    </div>
                                </template>
                                <template #default>
                                    <div class="flex flex-col items-center gap-5">
                                        <div class="flex w-full gap-5">
                                            <Button v-for="appointment_type in ['Onsite', 'Virtual', 'Home Service']" :key="item" type="secondary_gray" size="md" radius="rounded" class="w-full text-xs md:text-sm" @click="appointment.meta.appointment_type = appointment_type" :class="{ 'border border-[#D0D5DD] shadow-[0px_0px_0px_4px_#F2F4F7]': appointment.meta.appointment_type === appointment_type }">{{appointment_type }}</Button>
                                        </div>
                                        <div class="w-full">
                                            <Label>Address</Label>
                                            <Input v-model="appointment.meta.address" type="text" iconRight="edit05" class="my-1.5" />
                                        </div>
                                    </div>
                                </template>
							</Card>-->
							<!-- For Add Page -->
							<!-- <Button size="xl" type="primary" radius="square" classButton="w-full mt-10" @click.prevent="$router.push({ query: { tab: 'team' } })">Continue</Button> -->
							<!-- For Edit Page -->
							<div class="flex items-center gap-10">
								<!-- <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] mt-10 justify-between" @click.prevent="$router.push({ query: { tab: 'team' } })">
                                    <div class="w-[70%]">Back</div>
                                    <template #before>
                                        <Icon name="arrowNarrowLeft" size="20px"></Icon>
                                    </template>

								</Button>-->
								<Button v-if="$settings.addons.payment" @click="$router.push({ query: { ...route.query, tab: 'payment' } })" size="xl" type="primary" radius="square" classButton="w-full mt-10 justify-between">
									<div class="w-[95%]">Continue</div>
								</Button>
								<Button v-if="!$settings.addons.payment" :submit="true" publish @click.prevent="publish" size="xl" type="primary" radius="square" classButton="w-full mt-10 justify-between">
									<div class="w-[95%]">{{ publishButton }}</div>
								</Button>
							</div>
						</form>
					</template>
					<!-- Payment -->
					<template #payment>
						<form @submit.prevent="save">
							<Card cardClass="gap-5 mb-5">
								<template #header>
									<div class="flex flex-col gap-1">
										<div class="text-[#101828] text-lg font-semibold capitalize">Price & {{ $settings.labels.payment?.singular }}</div>
										<div class="text-[#667085] text-sm font-normal">Price of {{ String($settings.labels.service?.singular).toLowerCase() }} and {{ String($settings.labels.payment?.singular).toLowerCase() }} status</div>
									</div>
								</template>
								<template #default>
									<div class="flex flex-col items-center gap-2 md:gap-5 md:flex-row">
										<div class="w-full">
											<Label>Total Price</Label>
											<InputPrice v-model="appointment.meta.price" class="my-1.5" />
										</div>
									</div>
								</template>
							</Card>
							<Card cardClass="gap-5 mb-5">
								<template #header>
									<div class="flex justify-between gap-1">
										<div class="flex flex-col gap-1">
											<div class="text-[#101828] text-lg font-semibold">{{ $settings.labels.payment?.singular }} method and details</div>
											<div class="text-[#667085] text-sm font-normal">{{ $settings.labels.payment?.singular }} method used and it’s details</div>
										</div>
										<Toggle v-if="!isPaymentShow && isNew" v-model="isPaymentShow"></Toggle>
									</div>
								</template>
								<template #default>
									<div>
										<div v-if="isPaymentShow && isNew">
											<div class="flex items-center flex-col md:flex-row gap-5">
												<div class="w-full">
													<Label>Amount Paid</Label>
													<!-- <Input required v-model="state.paid_amount" type="number" placeholder="$" class="my-1.5" /> -->
													<InputPrice v-model="state.paid_amount" class="my-1.5" />
												</div>
												<div class="w-full">
													<Label class="capitalize">{{ $settings.labels.payment?.singular }} Method</Label>
													<Select required :options="$options.payment_methods" v-model="state.payment_method" class="my-1.5" selectionContainer="py-[10px]"></Select>
												</div>
												<div class="w-full">
													<Label class="capitalize">{{ $settings.labels.payment?.singular }} Status</Label>
													<Select required :options="{ paid: 'Paid', unpaid: 'Unpaid' }" v-model="state.payment_status" class="my-1.5" selectionContainer="py-[10px]"></Select>
												</div>
											</div>
											<!-- <div class="flex items-center gap-10 mt-5">
												<Button @click="toggleAddPayment()" size="xl" type="secondary_gray" radius="square" classButton="w-[45%]">
													<div class="w-[95%]">Cancel</div>
												</Button>
												<Button @click="submitAddPayment" size="xl" type="primary" radius="square" classButton="w-full">
													<div class="w-[95%]">Continue</div>
												</Button>
											</div>-->
									</div>
									<div v-if="!isNew">
										<div class="flex overflow-scroll md:overflow-visible">
											<div class="w-full">
												<div class="text-[#667085] text-sm font-normal bg-[linear-gradient(0deg,#EAECF0,transparent)] p-[0px_1px_1px_1px]">
													<div class="flex items-center gap-3 py-2.5 px-4 bg-white text-sm font-medium text-[#667085]">
														<div>Date</div>
													</div>
												</div>
												<div v-for="(transaction, index) in getTransactionsByAppointmentId" :key="index" class="py-[18px] px-4 border border-[#EAECF0] border-y-0 border-b text-sm font-medium text-[#344054] text-nowrap">{{ moment(transaction.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YY - hh:mm A') }}</div>
											</div>
											<div class="w-full">
												<div class="text-[#667085] text-sm font-normal bg-[linear-gradient(0deg,#EAECF0,transparent)] p-[0px_1px_1px_0px]">
													<div class="flex items-center gap-3 py-2.5 px-4 bg-white text-sm font-medium text-[#667085]">
														<div>Method</div>
													</div>
												</div>
												<div v-for="(transaction, index) in getTransactionsByAppointmentId" :key="index" class="py-[18px] px-4 capitalize border border-[#EAECF0] border-y-0 border-b border-l-0 text-sm font-medium text-[#344054] text-nowrap">{{ String(transaction.payment_method).split('_').join(' ') || 'Cash' }}</div>
											</div>
											<div class="w-full">
												<div class="text-[#667085] text-sm font-normal bg-[linear-gradient(0deg,#EAECF0,transparent)] p-[0px_1px_1px_0px]">
													<div class="flex items-center gap-3 py-2.5 px-4 bg-white text-sm font-medium text-[#667085]">
														<div>Status</div>
													</div>
												</div>
												<div v-for="(transaction, index) in getTransactionsByAppointmentId" :key="index" class="py-[16px] px-4 border border-[#EAECF0] border-l-0 border-y-0 border-b text-sm font-medium text-[#344054] text-nowrap">
													<div class="text-sm font-medium py-0.5 px-2.5 rounded-2xl w-fit capitalize" :class="{
                                                        'text-[#027A48] bg-[#ECFDF3]': transaction.payment_status == 'paid',
                                                        'text-[#B84646] bg-[#FEE2E2]': transaction.payment_status !== 'paid'
                                                    }">{{ transaction.payment_status || 'unpaid' }}</div>
												</div>
												<div class="py-[18px] px-4 capitalize border border-[#EAECF0] border-y-0 border-b text-sm font-medium text-[#344054] text-nowrap">Total Paid</div>
												<div class="py-[18px] px-4 capitalize border border-[#EAECF0] border-y-0 last:border-b text-sm font-medium text-[#344054] text-nowrap">Due Amount</div>
											</div>
											<div class="w-full">
												<div class="text-[#667085] text-sm font-normal bg-[linear-gradient(0deg,#EAECF0,transparent)] p-[0px_1px_1px_0px]">
													<div class="flex items-center gap-3 py-2.5 px-4 bg-white text-sm font-medium text-[#667085]">
														<div>Amount</div>
													</div>
												</div>
												<div v-for="(transaction, index) in getTransactionsByAppointmentId" :key="index" class="py-[18px] px-4 border border-[#EAECF0] border-x-0 border-r border-y-0 border-b text-sm font-medium text-[#344054] text-nowrap">{{ getPrice(transaction.payment_amount) }}</div>
												<!-- summery  -->
												<div class="py-[18px] px-4 border border-[#EAECF0] border-l-0 border-y-0 border-b text-sm font-medium text-[#344054] text-nowrap">{{ getPrice(totalPaid) }}</div>
												<!-- Due summery  -->
												<div class="py-[18px] px-4 border border-[#EAECF0] border-l-0 border-y-0 last:border-b text-sm font-medium text-[#344054] text-nowrap">{{ getPrice(totalDue) }}</div>
											</div>
										</div>

										<div>
											<form class="mt-4" @submit.prevent="submitTransaction()" v-if="state.addTransaction">
												<div class="flex items-center flex-col md:flex-row gap-5">
													<div class="w-full">
														<Label>Amount Paid</Label>
														<!-- <Input required v-model="state.paid_amount" type="number" placeholder="$" class="my-1.5" /> -->
														<InputPrice v-model="state.paid_amount" class="my-1.5" />
													</div>
													<div class="w-full">
														<Label class="capitalize">{{ $settings.labels.payment?.singular }} Method</Label>
														<Select required :options="paymentMethodOptions" v-model="state.payment_method" class="my-1.5" selectionContainer="py-[10px]"></Select>
													</div>
													<div class="w-full">
														<Label class="capitalize">{{ $settings.labels.payment?.singular }} Status</Label>
														<Select required :options="{ paid: 'Paid', unpaid: 'Unpaid' }" v-model="state.payment_status" class="my-1.5" selectionContainer="py-[10px]"></Select>
													</div>
												</div>

												<div class="flex items-center md:justify-end gap-3 mt-2">
													<Button size="sm" type="secondary_gray" radius="square" @click.prevent="state.addTransaction = false">Cancel</Button>
													<Button size="sm" type="primary" radius="square" submit>Submit</Button>
												</div>
											</form>

											<div v-if="!state.addTransaction" class="mt-2">
												<Button size="sm" type="primary" radius="square" @click.prevent="state.addTransaction = true">Add {{ String($settings.labels.payment?.singular).toLowerCase() }}</Button>
											</div>
										</div>
									</div>
									</div>
								</template>
							</Card>
							<!-- For Add Page -->
							<!-- <Button size="xl" type="primary" radius="square" classButton="w-full mt-10" @click.prevent="$router.push({ query: { ...route.query,tab: 'team' } })">Continue</Button> -->
							<!-- For Edit Page -->
							<div class="flex items-center gap-10">
								<Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] mt-10 justify-between" @click.prevent="$router.push({ query: { ...route.query, tab: 'details' } })">
									<div class="w-[70%]">Prev</div>
									<template #before>
										<Icon name="arrowNarrowLeft" size="20px"></Icon>
									</template>
								</Button>
								<Button :submit="true" publish @click.prevent="publish" size="xl" type="primary" radius="square" classButton="w-full mt-10 justify-between">
									<div class="w-[95%]">{{ publishButton }}</div>
								</Button>
							</div>
						</form>
					</template>
				</Tabs>
			</div>
		</template>
	</Modal>
</template>